import _groupBy from 'lodash/groupBy';
import { IInternalNotification } from 'types/internalNotifications';

export const groupByPriority = (data: IInternalNotification[]): IInternalNotification[][] => {
  return Object.values(_groupBy(data, 'priority'));
};

export const groupByType = (data: IInternalNotification[]) => {
  return _groupBy(data, 'msg_type');
};
